module.exports = __webpack_public_path__ + "assets/img/bg.1aa4cbb1.png";